module.exports = __webpack_public_path__ + "static/media/16.bfd00d64.png";